import { combineReducers } from 'redux'
import yearsReducer from '../modules/survey-data-visualization/years/YearsReducer'
import indicatorsReducer from '../modules/survey-data-visualization/indicators/IndicatorsReducer'
import regionsReducer from '../modules/survey-data-visualization/regions/RegionsReducer'
import isicsReducer from '../modules/survey-data-visualization/isics/IsicsReducer'
import dataResultsReducer from '../modules/survey-data-visualization/data-results/DataResultsReducer';
import directoryIsicsReducer from '../modules/directory-of-manufactory/directory-isics/DirectoryIsicsReducer'
import directoryRegionsReducer from '../modules/directory-of-manufactory/directory-regions/DirectoryRegionsReducer' 
import directorySearchDataReducer from '../modules/directory-of-manufactory/directory-search-data/DirectorySearchDataReducer' 
import internationalizationReducer from '../common/internationalization/InternationalizationReducer'
import loginReducer from '../common/login/login-form/LoginReducer'
import directoryProductsReducer from '../modules/directory-of-manufactory/directory-products/DirectoryProductsReducer';
import dynamicSurveyReducer from '../modules/dynamic-survey/DynamicSurveyReducer';
import establishmentsReducer from '../modules/dynamic-survey/establishments/EstablishmentsReducer';
import resetPasswordReducer from  '../common/login/reset-password-form/ResetPasswordReducer';

const RootReducer = combineReducers({
  yearsReducer,
  indicatorsReducer,
  regionsReducer,
  isicsReducer,
  dataResultsReducer,
  directoryIsicsReducer,
  directoryRegionsReducer,
  directorySearchDataReducer,
  internationalizationReducer,
  loginReducer,
  directoryProductsReducer,
  dynamicSurveyReducer,
  establishmentsReducer,
  resetPasswordReducer
})
 
export default RootReducer


// WEBPACK FOOTER //
// ./src/features/root/RootReducer.js